module.exports = __webpack_public_path__ + "img/fig05.d0217aee.jpg";